import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormSection,
  FormWrapper,
  Form,
  Label,
  Input,
  TextArea,
  Button,
  InputWrapper,
  ContactUs,
  Question,
  FormImg,
  TitleWrapper,
  FormImgWrapper,
  TitleTextWrapper,
} from './Form.styled';

import useForm from './Form.services';

import Modal from '../Modal/Modal';
import Validation from '../../helpers/validation';
import FormIco from '../../assets/images/Ask.webp';
import { Success } from '../Success';

export const FormComponent = () => {
  const {
    send,
    email,
    changeEmail,
    emailError,
    phone,
    changePhone,
    phoneError,
    message,
    changeMessage,
    messageError,
    showTroubleModal,
    showSucceessModal,
    closeSuccess
  } = useForm();

  const {
    emailValidation,
    phoneValidation,
    messageValidation,
  } = Validation();

  const [flag, setFlag] = useState(false);
  const hover = () => setFlag(true);
  const unHover = () => setFlag(false);

  const { t } = useTranslation();
  const emailValidate = emailValidation(email);
  const phoneValidate = phoneValidation(phone);
  const messageValidate = messageValidation(message);
  type props = { t: string };
  const existTranslate = ({ t: key }: props) =>
    t(key) !== key;

  const width =
    typeof window !== 'undefined' ? window.innerWidth : 0;
  const isDesktop = width >= 1280;
  return (
    <>
      <FormSection>
        <FormWrapper>
        <TitleWrapper>
          <TitleTextWrapper>
            <ContactUs>{t('contuctUs')}</ContactUs>
            <Question>{t('question')}</Question>
          </TitleTextWrapper>

          {isDesktop ? (
            <FormImgWrapper>
              <FormImg src={FormIco} alt='question' />
            </FormImgWrapper>
          ) : null}
        </TitleWrapper>
        <Form onSubmit={send}>
          <InputWrapper>
            {emailError && (
              <Label htmlfor='inputEmail'>
                {emailValidate}
              </Label>
            )}
            {existTranslate({ t: 'email' }) && (
              <Input
                id='inputEmail'
                placeholder={t('email')}
                type='email'
                value={email}
                autoComplete='off'
                onChange={changeEmail}
                error={emailError}
              />
            )}
          </InputWrapper>
          <InputWrapper>
            {phoneError && (
              <Label htmlfor='inputPhone'>
                {phoneValidate}
              </Label>
            )}
            {existTranslate({ t: 'phone' }) && (
              <Input
                id='inputPhone'
                placeholder={t('phone')}
                type='tel'
                autoComplete='off'
                value={phone}
                onChange={changePhone}
                error={phoneError}
              />
            )}
          </InputWrapper>
          <InputWrapper>
            {messageError && (
              <Label htmlfor='inputMessage'>
                {messageValidate}
              </Label>
            )}
            {existTranslate({ t: 'message' }) && (
              <TextArea
                placeholder={t('message')}
                value={message}
                onChange={changeMessage}
                error={messageError}
              />
            )}
          </InputWrapper>
          <Button
            type='submit'
            onMouseEnter={hover}
            onMouseLeave={unHover}
            hovered={flag}>
            {t('send')}
          </Button>
          
        </Form>
        {!isDesktop ? (
          <FormImg src={FormIco} alt='question' />
        ) : null}
        {showTroubleModal?<Modal />:null}
        {showSucceessModal?<Success closeSuccess={closeSuccess} />:null}
        </FormWrapper>
        
      </FormSection>
    </>
  );
};
